import * as Sentry from '@sentry/react';

import { useAuthStore } from '../store/authStore';

let installed = false;

type AuthState = ReturnType<typeof useAuthStore.getState>;

function syncSentryUser(user: AuthState['user'], supportSession: AuthState['supportSession']) {
  if (!user) {
    Sentry.setUser(null);
    Sentry.setTag('user.type', 'anonymous');
    Sentry.setTag('user.role', 'anonymous');
    Sentry.setTag('team.id', 'none');
    Sentry.setTag('team.has_team', 'false');
    Sentry.setTag('support.masquerading', 'false');
    Sentry.setTag('account.disabled', 'false');
    Sentry.setContext('app_user', null);
    return;
  }

  const userType = user.role;
  const supportMasquerading = supportSession != null;

  Sentry.setUser({
    id: user.id,
    segment: userType,
  });
  Sentry.setTag('user.type', userType);
  Sentry.setTag('user.role', user.role);
  Sentry.setTag('team.id', user.teamId ?? 'none');
  Sentry.setTag('team.has_team', user.teamId ? 'true' : 'false');
  Sentry.setTag('support.masquerading', supportMasquerading ? 'true' : 'false');
  Sentry.setTag('account.disabled', user.accountDisabled === true ? 'true' : 'false');
  Sentry.setContext('app_user', {
    type: userType,
    role: user.role,
    additionalRoles: user.additionalRoles ?? [],
    teamId: user.teamId,
    hasTeam: user.teamId != null,
    accountDisabled: user.accountDisabled === true,
    supportMasquerading,
    supportUserId: supportSession?.user.id ?? null,
  });
}

export function installSentryUserSync() {
  if (installed) {
    return;
  }
  installed = true;

  const initial = useAuthStore.getState();
  syncSentryUser(initial.user, initial.supportSession);

  useAuthStore.subscribe((state) => {
    syncSentryUser(state.user, state.supportSession);
  });
}
